module.exports = __webpack_public_path__ + "static/media/oprava-kostela.96cf71b6.jpg";